import * as axiosService from "./../axiosService";

 export const getNotification = (pageNumber,pageSize) => {
    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Account/GetNotificationList?pageNumber=${pageNumber}&pageSize=${pageSize}`);
 };

 export const readNotification = (payload)=>{
   return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL+`/Account/ReadNotification`,payload)
 }